/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MarketShoppingCartIcon16Solid = forwardRef('MarketShoppingCartIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M0 3a1 1 0 0 1 1-1h2.096a1.5 1.5 0 0 1 1.466 1.186L4.737 4H14a1 1 0 0 1 .98 1.196l-.758 3.794A2.5 2.5 0 0 1 11.77 11H6.213a2.5 2.5 0 0 1-2.445-1.976L2.692 4H1a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M5.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }),
        React.createElement("path", { d: "M11.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" })));
});
